export default{
    data() {
        return {
            errors: [],
            formSubmitted: false,
            valid: false,
            form: {},
            errors: {}
        }
    },
    methods: {
        setForm(employer) {
            this.clearForm();

            this.form = {
                id: employer.id ? employer.id : 0,
                name: employer.name ? employer.name : '',
                rfc: employer.rfc ? employer.rfc : '',
                registro_patronal: employer.registro_patronal ? employer.registro_patronal : '',
                zipcode: employer.zipcode ? employer.zipcode : ''
            }
        },
        clearForm() {
            this.form = {
                id: 0,
                name: '',
                rfc: '',
                registro_patronal: '',
                zipcode: '',
            };

            this.clearErrors();

            this.formSubmitted = false;
            this.showModal = true;
        },
        clearErrors() {
            this.errors = {
                name: false,
                rfc: false,
                registro_patronal: false,
                zipcode: false,
            };
        },
        storeEmployerValidation() {
            this.formSubmitted = true;
            
            if(this.isStoreValid()){
                this.storeEmployer(this.form);

                this.clearForm();
            }
        },
        isStoreValid(){
            this.valid = true;

            this.clearErrors();
            
            if(this.form.name.length == 0){
                this.errors.name = "El nombre es obligatorio."
                this.valid = false;
            }

            if(this.form.rfc.length == 0){
                this.errors.rfc = "El RFC es obligatorio."
                this.valid = false;
            }

            if(this.form.registro_patronal.length == 0){
                this.errors.registro_patronal = "El Registro Patronal es obligatorio."
                this.valid = false;
            }

            if(this.form.zipcode.length == 0){
                this.errors.zipcode = "El Código Postal es obligatorio."
                this.valid = false;
            }
            
            return this.valid;
        },
        updateEmployerValidation() {
            this.formSubmitted = true;
            
            if(this.isUpdateValid()){
                this.updateEmployer(this.form);

                this.clearForm();
            }
        },
        isUpdateValid(){
            this.valid = true;

            this.clearErrors();
            
            if(this.form.name.length == 0){
                this.errors.name = "El nombre es obligatorio."
                this.valid = false;
            }

            if(this.form.rfc.length == 0){
                this.errors.rfc = "El RFC es obligatorio."
                this.valid = false;
            }

            if(this.form.registro_patronal.length == 0){
                this.errors.registro_patronal = "El Registro Patronal es obligatorio."
                this.valid = false;
            }

            if(this.form.zipcode.length == 0){
                this.errors.zipcode = "El Código Postal es obligatorio."
                this.valid = false;
            }

            return this.valid;
        },
        deleteEmployerValidation() {
            this.formSubmitted = true;
            
            this.deleteEmployer(this.form);

            this.clearForm();
        },
    }
}